import angular from 'angular';

/* Normal select directive */
angular.module('cxTaskflow').directive('cxAssignedToSelect', function() {
  return {
    restrict: 'E',
    template: `<select ng-model="ctrl.value" class="form-control" ng-change="ctrl.valueChanged()">
                  <option ng-if="ctrl.nullValue" value="null;">{{ctrl.nullValue}}</option>
                  <option value="0;">{{ctrl.placeholder || ('Unassigned'|translate)}}</option>
                  <optgroup label="{{('Profiles'|translate)}}">
                    <option value="1;{{profile.id}}" ng-repeat="profile in ctrl.profiles | orderBy:'label'">{{profile.label}}</option>
                  </optgroup>
                  <optgroup label="{{('Users'|translate)}}">
                    <option value="2;{{user.id}}" ng-repeat="user in ctrl.users | orderBy:'label'" ng-class="{'removed-user':!user.isActive}">{{user.label}}</option>
                  </optgroup>
                </select>`,
    scope: {
      users: '=',
      profiles: '=',
      placeholder: '@?',
      nullValue: '@?',
    },
    bindToController: true,
    require: ['ngModel', 'cxAssignedToSelect'],
    link: function(scope, el, attrs, controllers) {
      if (!controllers || controllers.length !== 2) return;
      var ngModel = controllers[0];
      var ctrl = controllers[1];

      ctrl.view2model = function(value) {
        ngModel.$setViewValue(value);
      };

      // when angular detects a change to the model,
      // we update our inner value
      ngModel.$render = function() {
        ctrl.setValue(ngModel.$viewValue);
      };
    },
    controllerAs: 'ctrl',
    controller: [
      function() {
        const ctrl = this;
        ctrl.value = null;
        ctrl.valueChanged = function() {
          if (!ctrl.view2model) return;
          var oValue = {
            assignedType: 0,
            userId: null,
            profile: null,
          };

          if (typeof ctrl.value === 'string') {
            var parts = ctrl.value.split(';');
            if (parts[0].length && parts[0] === 'null') {
              if (parts[0] === 'null')
                oValue = {
                  ...oValue,
                  assignedType: null,
                  userId: null,
                  profile: null,
                };
            }
            if (parts[0].length && parts[1].length)
              if (parts.length === 2) {
                if (parts[0] === '1')
                  oValue = {
                    ...oValue,
                    assignedType: 1,
                    profile: parseInt(parts[1]),
                  };
                else if (parts[0] === '2')
                  oValue = {
                    ...oValue,
                    assignedType: 2,
                    userId: parts[1],
                  };
              }
          }
          ctrl.view2model(oValue);
        };

        ctrl.setValue = function({ assignedType = null, userId = null, profile = null } = {}) {
          if (assignedType === 1 && profile) {
            ctrl.value = '1;' + profile;
          } else if (assignedType === 2 && userId) {
            ctrl.value = '2;' + userId;
          } else if (assignedType === 0) {
            ctrl.value = '0;';
          } else if (ctrl.nullValue) {
            ctrl.value = 'null;';
          } else {
            ctrl.value = '0;';
          }
        };
      },
    ],
  };
});
